"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disabledCountries = exports.shippingCountriesRedirects = exports.countriesWithTax = exports.euCountries = void 0;
exports.euCountries = [
    'IT',
    'NO',
    'ES',
    'AT',
    'FI',
    'FR',
    'DE',
    'GR',
    'IE',
    'LU',
    'NL',
    'PT',
    'SE',
    'CH',
];
exports.countriesWithTax = __spreadArray(['US', 'CA', 'GB'], exports.euCountries, true);
exports.shippingCountriesRedirects = {
    QA: 'AE',
    BH: 'AE',
};
exports.disabledCountries = ['BH', 'QA'];
